'use strict';

(function() {
	angular.module('onboarding.internaladmin')
		.directive('cobAdminBrokerList', cobAdminBrokerList);

	cobAdminBrokerList.$inject = [
		'subjectObserverMessagesService', 'observerService', 'internalAdminService', 'sessionService', '$state'
	];

	var subjectObserverMessagesService,
		observerService,
		internalAdminService,
		subjectMessages,
		observerMessages,
		sessionService,
		state;

	function cobAdminBrokerList(_subjectObserverMessagesService_,
		_observerService_,
		_internalAdminService_,
		_sessionService_,
		_state_) {
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		internalAdminService = _internalAdminService_;
		sessionService = _sessionService_;
		state = _state_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/internaladmin/cobAdminBrokerList.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.ajaxIsRunning = false;
			scope.brokers = [];
			scope.searchType = 'companyName';
			scope.setFilter = setFilter;
			scope.sortReverse = false;
			scope.sortType = 'activeDate';

			scope.hideAssureSignIdModal = hideAssureSignIdModal;
			scope.masqueradeClick = masqueradeClick;
			scope.searchClick = searchClick;
			scope.searchTypeChange = searchTypeChange;
			scope.sortClicked = sortClicked;
			scope.searchInputKeyPress = searchInputKeyPress;
			scope.showAssureSignIdModal = showAssureSignIdModal;
			scope.clearSearchClicked = clearSearchClicked;
			scope.searchInputChange = searchInputChange;
			scope.isSearch = false;

			setFilter('Active');
			searchTypeChange();
			getBrokers();
			document.title = 'Admin - Brokers';
		}

		function masqueradeClick(brokerId, brokerName, domain) {
			sessionService.setBrokerImpersonated(brokerId, brokerName, domain);
		}

		function getBrokers() {
			if (scope.ajaxIsRunning) {
				return;
			}

			scope.ajaxIsRunning = true;
			setTimeout(function() {
				observerService.sendMessageToSubject(scope,
					subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
			},
			1);

			internalAdminService.getBrokers()
				.then(function(response) {
					scope.brokers = response.data.brokers;
				})
				.finally(function() {
					scope.ajaxIsRunning = false;
					observerService.sendMessageToSubject(scope,
						subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
				});

			return;
		}

		function hideAssureSignIdModal() {
			scope.displayAssureSignIdModal = false;
		}

		function searchClick() {
			scope.isSearch = true;
			scope.filter = '';
			setfilterExpr();
		}

		function searchTypeChange() {
			scope.searchValue = '';
			if (scope.searchType === 'accountId') {
				scope.searchInputPlaceholder = 'e.g. 182789';
			} else if (scope.searchType === 'guid') {
				scope.searchInputPlaceholder = 'e.g. DECA1A5E-3147-483D-BC7E-E5F601A205F9';
			}
			else {
				scope.searchInputPlaceholder = 'e.g. Sample Company';
			}

		}

		function setFilter(filter) {
			scope.filter = filter;
			setfilterExpr();
		}

		function setfilterExpr() {
			if (scope.filter) {
				scope.filterExpr = { status: scope.filter };
				scope.searchExact = true;
			} else if (scope.searchType === 'companyName') {
				scope.filterExpr = { companyName: scope.searchValue };
				scope.searchExact = false;
			} else if (scope.searchType === 'accountId') {
				scope.filterExpr = { accountId: scope.searchValue };
				scope.searchExact = false;
			} else if (scope.searchType === 'guid') {
				scope.filterExpr = { guid: scope.searchValue.toUpperCase() };
				scope.searchExact = true;
			}
		}

		function sortClicked(sortType) {
			if (scope.sortType === sortType) {
				scope.sortReverse = !scope.sortReverse;

				return;
			} else {
				scope.sortType = sortType;
				scope.sortReverse = false;
			}
		}

		function searchInputKeyPress(event) {
			var charCode = (event.which) ? event.which : event.keyCode;
			if (charCode === 13) { // on Enter
				searchClick();
				event.preventDefault();

				return;
			}
		}

		function showAssureSignIdModal(broker) {
			scope.displayAssureSignIdModal = true;
			scope.assuresignBrokerId = broker.brokerId;
			scope.assuresignBrokerName = broker.companyName;
			scope.assuresignBrokerDomain = broker.domain;
		}

		function clearSearchClicked() {
			scope.isSearch = false;
			scope.searchValue = '';
			setFilter('Active');
		}

		function searchInputChange() {
			switch (scope.searchType) {
			case 'companyName':
				scope.searchValue = scope.searchValue.substring(0, 150);
				break;
			case 'accountId':
				scope.searchValue = scope.searchValue.substring(0, 8);
				break;
			case 'guid':
				scope.searchValue = scope.searchValue.substring(0, 50);
				break;
			}
		}
	}
})();
